<template>
    <section class="business-areas">
        <div>
            <v-tabs v-model="tab" :change="changeTab(tab)"
                    next-icon="mdi-arrow-right-bold-box-outline"
                    prev-icon="mdi-arrow-left-bold-box-outline"
                    show-arrows>
                <v-tabs-slider></v-tabs-slider>
                <v-tab v-for="item in items">
                    <span>
                           {{ item.label }}
                    </span>
                </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
                <v-tab-item v-for="item in items">
                    <v-card flat>
                        <div class="business-areas__content">
                            <div class="business-areas__img">
                                <img :src="item.src" alt="">
                            </div>
                            <div class="business-areas__descr d-flex flex-column justify-content-center">
                                <div class="business-areas__title">{{ item.label }}</div>
                                <div class="business-areas__text" v-html="item.descr"></div>
                                <div class="business-areas__table">
                                    <div class="business-areas__table--item"
                                         v-for=" itemTable in item.table">
                                        {{ itemTable.name }}
                                        <span>{{ itemTable.quantity }}</span>
                                    </div>
                                </div>
                                <a class="business-areas__btn btn-red " :href="item.url">Подробнее</a>
                            </div>

                        </div>
                    </v-card>
                </v-tab-item>
            </v-tabs-items>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        items: Array | String | Number | Boolean | Object,
    },
    name: "businessAreasNew",
    data() {
        return {
            tab: null,
            // items: [
            //     {
            //         label: "Транспортная упаковка",
            //         src: "/upload/transport.jpg",
            //         descr: "Мы крупнейших производитель и дистрибьютор транспортной упаковки. Инвестиции в развитие высокотехнологичной упаковки позволяют бизнесу предлагать лучшие решения для транспортировки грузов.",
            //         url: "#",
            //         table: [
            //             {
            //                 name: 'Производственных площадок ',
            //                 quantity: '5'
            //             },
            //             {
            //                 name: 'Объем производства стретч-плёнки',
            //                 quantity: '180 000 тонн/год'
            //             },
            //             {
            //                 name: 'Объем производства клейких лент',
            //                 quantity: '1 100 000 000 тонн/год'
            //             },
            //             {
            //                 name: 'Объем производства пакетов',
            //                 quantity: '65 000 тонн/год'
            //             },
            //         ]
            //     },
            //     {
            //         label: "Потребительская упаковка",
            //         src: "/upload/transport.jpg",
            //         descr: "Мы крупнейших производитель и дистрибьютор транспортной упаковки. Инвестиции в развитие высокотехнологичной упаковки позволяют бизнесу предлагать лучшие решения для транспортировки грузов.",
            //         url: "#",
            //         table: [
            //             {
            //                 name: 'Производственных площадок ',
            //                 quantity: '5'
            //             },
            //             {
            //                 name: 'Объем производства стретч-плёнки',
            //                 quantity: '180 000 тонн/год'
            //             },
            //             {
            //                 name: 'Объем производства клейких лент',
            //                 quantity: '1 100 000 000 тонн/год'
            //             },
            //             {
            //                 name: 'Объем производства пакетов',
            //                 quantity: '65 000 тонн/год'
            //             },
            //         ]
            //     },
            //     {
            //         label: "Химические решения",
            //         src: "/upload/transport.jpg",
            //         descr: "Мы крупнейших производитель и дистрибьютор транспортной упаковки. Инвестиции в развитие высокотехнологичной упаковки позволяют бизнесу предлагать лучшие решения для транспортировки грузов.",
            //         url: "#",
            //         table: [
            //             {
            //                 name: 'Производственных площадок ',
            //                 quantity: '5'
            //             },
            //             {
            //                 name: 'Объем производства стретч-плёнки',
            //                 quantity: '180 000 тонн/год'
            //             },
            //             {
            //                 name: 'Объем производства клейких лент',
            //                 quantity: '1 100 000 000 тонн/год'
            //             },
            //             {
            //                 name: 'Объем производства пакетов',
            //                 quantity: '65 000 тонн/год'
            //             },
            //         ]
            //     },
            //     {
            //         label: "Этикеточные решения",
            //         src: "/upload/transport.jpg",
            //         descr: "Мы крупнейших производитель и дистрибьютор транспортной упаковки. Инвестиции в развитие высокотехнологичной упаковки позволяют бизнесу предлагать лучшие решения для транспортировки грузов.",
            //         url: "#",
            //         table: [
            //             {
            //                 name: 'Производственных площадок ',
            //                 quantity: '5'
            //             },
            //             {
            //                 name: 'Объем производства стретч-плёнки',
            //                 quantity: '180 000 тонн/год'
            //             },
            //             {
            //                 name: 'Объем производства клейких лент',
            //                 quantity: '1 100 000 000 тонн/год'
            //             },
            //             {
            //                 name: 'Объем производства пакетов',
            //                 quantity: '65 000 тонн/год'
            //             },
            //         ]
            //     },
            //
            // ]
        }
    },
    methods: {
        changeTab(item) {
            console.log("changeTab")
        },
    }
}
</script>


<style scoped lang="scss">

.business-areas {

  &__content {
    display: grid;
    grid-template-columns: 1fr 1.5fr;
    gap: 8px;

    @media (max-width: 1400px) {
      grid-template-columns: 1fr;
    }
  }

  &__descr {
    background: #F5F5F7;
    border-radius: 40px;
    padding: 48px;


    @media (max-width: 766px) {
      width: 100%;
      min-height: 238px;
    }

    @media (max-width: 425px) {
      padding: 24px;
    }
  }

  &__title {
    font-family: 'MuseoSansCyrl-500';
    font-weight: 400;
    font-size: 56px;
    line-height: 72px;
    letter-spacing: -2.24px;
    color: #212424;
    margin-bottom: 48px;

    @media (max-width: 1600px) {
      font-size: 50px;
      line-height: 62px;
    }

    @media (max-width: 768px) {
      font-size: 44px;
      line-height: 56px;
    }

    @media (max-width: 425px) {
      font-size: 34px;
      line-height: 42px;
      margin-bottom: 24px;
    }
  }

  &__text {
    font-family: 'RobotoRegular';
    font-weight: 400;
    font-size: 28px;
    line-height: 36px;
    letter-spacing: 0px;
    color: #212424;
    margin-bottom: 48px;

    @media (max-width: 1600px) {
      font-size: 24px;
      line-height: 30px;
    }

    @media (max-width: 768px) {
      font-size: 20px;
      line-height: 26px;
    }

    @media (max-width: 425px) {
      font-size: 16px;
      line-height: 22px;
      margin-bottom: 24px;
    }
  }

  &__img {

    & img {
      border-radius: 40px;
      width: 100%;
      max-width: 720px;
      object-fit: cover;

      @media (max-width: 1400px) {
        max-width: unset;
        object-fit: cover;
        height: auto;
        max-height: 600px;
      }

    }
  }

  &__btn {
    max-width: max-content;
  }

  &__table {
    margin-bottom: 48px;

    &--item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 16px 0;
      border-bottom: 1px solid #D2D2D2;

      font-family: 'RobotoRegular';
      font-weight: 400;
      font-size: 28px;
      line-height: 40px;
      letter-spacing: 0px;
      color: #7D7D7D;

      @media (max-width: 1600px) {
        font-size: 24px;
        line-height: 26px;
      }

      @media (max-width: 768px) {
        font-size: 20px;
        line-height: 24px;
        display: grid;
        grid-template-columns: 1fr;
      }

      @media (max-width: 500px) {
        font-size: 18px;
        line-height: 22px;
      }

      & > span {
        color: #212424;

        @media (max-width: 768px) {
          display: block;
          margin-top: 10px;
        }
      }
    }
  }
}
</style>

<style lang="scss">

// общие стили для табов

.business-areas,
.enterprise-map,
.recommend {

  .v-tabs-bar {
    height: 60px;
  }

  .v-tab:not(.v-tab--active) {
    & svg {
      display: none;
    }
  }

  .v-ripple__container {
    display: none;
  }

  & .v-tabs-slider {
    height: 0;
  }

  .v-tabs:not(.v-tabs--vertical):not(.v-tabs--right) > .v-slide-group--is-overflowing.v-tabs-bar--is-mobile:not(.v-slide-group--has-affixes) .v-slide-group__prev {
    display: none;
  }

  .v-tabs {
    @media (max-width: 766px) {
      max-width: 90vw;
    }
  }

  & .v-tab {
    gap: 14px;
    margin: 5px;
    border: 1px solid #E4E4E4;
    background: #FFFFFF;
    border-radius: 40px;
    padding: 12px 24px;
    height: 52px;
    width: 100%;
    min-width: max-content;

    &:before {
      background-color: transparent !important;
    }

    &:hover {
      opacity: 1 !important;
      border: 1px solid #4F4D55;
    }

    & > span {
      font-family: 'MuseoSansCyrl-500';
      font-size: 20px;
      font-weight: 500;
      line-height: 28px;
      letter-spacing: 0;
      color: #4F4D55 !important;
      text-transform: none;
    }
  }


  & .v-tab--active {
    border: 1px solid #FA4237;

    &:before {
      background-color: transparent !important;
    }

    &:hover {
      opacity: 1 !important;
      border: 1px solid #FA4237;
    }

    & > span {
      color: #FA4237 !important;
    }
  }

  .v-slide-group {
    &__content {
      gap: 10px;
    }
  }

  .v-item-group {
    margin-top: 40px;

    &.v-tabs-items {
      border-bottom-left-radius: 20px;
      border-top-left-radius: 20px;
      box-shadow: 0px 4px 4px 0px #00000005;

      @media (max-width: 766px) {
        border-bottom-left-radius: 0;
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
      }
    }

    .theme--light.v-card {
      background-color: transparent;
    }

  }

  .v-item-group.v-tabs-items {
    box-shadow: none !important;
  }

  .v-slide-group__wrapper {
    height: 75px;
  }

  & .v-tabs-bar,
  & .theme--light.v-tabs-items {
    background-color: transparent !important;
  }

  .v-slide-group:not(.v-slide-group--has-affixes) > .v-slide-group__prev, .v-slide-group:not(.v-slide-group--has-affixes) > .v-slide-group__next {
    display: none;
  }

  .mdi-arrow-right-bold-box-outline::before {
    content: '';
    background: url("/upload/chevron-right.svg") no-repeat;
    background-size: contain;
    width: 40px;
    height: 40px;
  }

  .mdi-arrow-left-bold-box-outline::before {
    content: '';
    background: url("/upload/chevron-right.svg") no-repeat;
    background-size: contain;
    width: 40px;
    height: 40px;
    rotate: 180deg;
  }

  .v-slide-group__next, .v-slide-group__prev {
    min-width: 33px;
  }
}

</style>